interface ChartAnimationConfig {
  animationBegin?: number
  animationDuration: number
  animationEasing?: 'ease-in' | 'ease-out' | 'ease-in-out' | 'linear'
}

interface GetChartAnimationConfigProps {
  isDashed?: boolean
  isInView: boolean
  animateWhenInView: boolean
  chartResetKey?: string | number
  isEstimated?: boolean
}

export const getChartAnimationConfig = ({
  animateWhenInView,
  chartResetKey,
  isDashed = false,
  isEstimated = false,
  isInView,
}: GetChartAnimationConfigProps): ChartAnimationConfig => {
  const getAnimationDuration = () => {
    if (!animateWhenInView) return 800
    if (!isInView) return 0

    switch (chartResetKey) {
      case '+1Y':
        return 2000
      case '+5Y':
        return 1500
      default:
        return 4000
    }
  }

  const getAnimationBegin = () => {
    if (!animateWhenInView) return isDashed ? 800 : 0
    return isInView ? getAnimationDuration() : 0
  }

  const getAnimationEasing = () => {
    if (!animateWhenInView) return 'ease-in-out'
    return isEstimated ? 'ease-out' : 'ease-in'
  }

  if (isDashed) {
    return {
      animationBegin: getAnimationBegin(),
      animationDuration: getAnimationDuration(),
      animationEasing: getAnimationEasing(),
    }
  }

  return {
    animationDuration: getAnimationDuration(),
    animationEasing: getAnimationEasing(),
  }
}
